// 快速拼图——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `picture/index${i + 1}`,
  name: `pictureIndex${i + 1}`,
  component: () => import(`@/views/edit/picture/index${i + 1}.vue`)
}))

import pictureIndex from '@/views/edit/picture/index'

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
          {
            path: 'picture/index',
            name: 'pictureIndex',
            component: pictureIndex
          },
    // 快速拼图——主流程，开始
    ...MainRoutes,

  ],
};
